import React, { PureComponent, Fragment } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import { withTranslation } from 'react-i18next';

import ContactSalesForm from '../forms/ContactSalesForm';
import CenterModal from '../modal/CenterModal';

const ContactSales = DisplayComponent(
  class ContactSales extends PureComponent {
    state = {
      open: false
    };

    handleLinkClick = e => {
      e.preventDefault();
      this.setState({
        open: true
      });
    };
    handleClose = () => {
      this.setState({
        open: false
      });
    };

    render() {
      const {
        linkText,
        classes,
        displayType,
        buttonColor,
        path,
        t
      } = this.props;
      const { open } = this.state;
      return (
        <Fragment>
          {displayType === 'link' && (
            <button
              className={classes}
              onClick={this.handleLinkClick}
              onKeyUp={this.handleLinkClick}
              tabIndex="0"
            >
              {linkText}
            </button>
          )}
          {displayType === 'button' && (
            <Button
              className={classes}
              to="#"
              color={buttonColor}
              onClick={e => this.handleLinkClick(e)}
            >
              {linkText}
            </Button>
          )}
          {open ? (
            <CenterModal
              id="contact-sales"
              onClose={this.handleClose}
              width="1200px"
            >
              <ContactSalesForm
                path={path}
                onClose={() => this.handleClose()}
                title={t('Contact Sales')}
                buttonText={t('Contact Sales')}
              />
            </CenterModal>
          ) : null}
        </Fragment>
      );
    }
  }
);
export default withTranslation()(ContactSales);
